import { isGID, type GID, type UnlikelyProduct } from "@unlikelystudio/commerce-connector"

import type { PropsWithClassName } from "~/@types/generics"
import { productMetafields, productVariantMetafields } from "~/lib/shopify/constants"
import { getSfProductsByIds } from "~/lib/shopify/queries/get-sf-products-by-id"
import { getLocalizedMetafields } from "~/lib/shopify/utils/get-localized-metafields"
import { metafieldsToObject } from "~/utils/metafields-to-object"
import { objectValues } from "~/utils/object-values"
import { safeJSONParse } from "~/utils/safe-json-parse"
import type { ProductPageProps } from "~/app/[locale]/products/[slug]/page"

type LinkedProductsProps = PropsWithClassName<
  {
    product: UnlikelyProduct
  } & ProductPageProps
>

export type FetchLinkedProductsParams = Pick<LinkedProductsProps, "product"> &
  Pick<LinkedProductsProps["params"], "locale">

export async function fetchLinkedProducts({ product, locale }: FetchLinkedProductsParams) {
  const metafields = metafieldsToObject(product?.metafields ?? {}, getLocalizedMetafields(productMetafields, locale))
  const ids = safeJSONParse<GID[]>(metafields?.productSiblings)?.filter(isGID) ?? []

  if (!ids || !product?.id) return { products: [] }

  return await getSfProductsByIds({
    locale: locale,
    ids,
    metafieldKeys: objectValues(getLocalizedMetafields(productMetafields, locale)),
    metafieldVariantsKeys: objectValues(getLocalizedMetafields(productVariantMetafields, locale)),

    nextTags: [product?.id],
  })
}
